import React from 'react';
import { useSvgIconStylesContext } from './SvgIconStylesContext';

export interface SvgIconFactoryParams {
    Svg: (props: React.SVGAttributes<unknown>) => JSX.Element;
    displayName: string;
}

export default function CreateSvgIcon({ Svg, displayName }: SvgIconFactoryParams): any {
    const IconComponent: React.FC<React.SVGAttributes<unknown>> = () => {
        const { iconStyles } = useSvgIconStylesContext();
        return <Svg className={iconStyles} />;
    };

    IconComponent.displayName = displayName;

    return IconComponent;
}
